/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { InputColumn, TableColumn } from './InputInterface';
import { RowDataInfo } from '../../../question/questionInterfaces';

export function updateRowData<T extends { id: number | string } = RowDataInfo>(data: T[], row: Partial<T>) {
  let found = false;
  const newData = data.map(r => {
    if (r.id === row.id) {
      found = true;
      return { ...r, ...row }
    }
    return r;
  })
  return found ? newData : data;
}

const invalidValues: (undefined | string | null | number | string[])[] = [undefined, '', null,];

export const isDisabled = (columns: TableColumn[], data: InputColumn[]) => {
  if (data.length === 0 || data.every(({ value }) => invalidValues.includes(value))) {
    return true;
  }

  return data.some(({ value, code }) => {
    const colMetaData = columns.find(col => col.code === code);
    if (value !== undefined && !Array.isArray(value)) {
      if (colMetaData?.validation?.min !== undefined) {
        if (Number(value) < colMetaData.validation.min) {
          return true;
        }
      }
      if (colMetaData?.validation?.max !== undefined) {
        if (Number(value) > colMetaData.validation.max) {
          return true;
        }
      }
      return false;
    }

    if (colMetaData?.validation?.required) {
      if (Array.isArray(value)) {
        if (value.some(v => invalidValues.includes(v))) {
          return true;
        }
      } else if (invalidValues.includes(value)) {
        return true;
      }
    }
    return false;
  });
}
